export default () =>
  import(/* webpackChunkName: 'coffee/activities/luckincard/auto-renew' */ './AutoRenew');
